/**
 * Totales de checkout público (menú + asistente).
 * Fuente única para subtotal, envío y total antes de validar pago.
 */

export function computeCheckoutDeliveryFee(serviceType, deliveryQuote) {
  if (serviceType !== 'delivery') return 0;
  if (typeof deliveryQuote?.delivery_fee !== 'number') return null;
  return deliveryQuote.delivery_fee;
}

/**
 * @param {{ serviceType: string, deliveryQuote?: object|null, getCartTotal?: () => number, tip?: number }} p
 * @returns {{ subtotal: number, delivery: number|null, total: number|null }}
 */
export function computeCheckoutTotals(p) {
  const subtotal =
    typeof p.getCartTotal === 'function' ? Number(p.getCartTotal()) || 0 : 0;
  const delivery = computeCheckoutDeliveryFee(p.serviceType, p.deliveryQuote);
  const tip = Number(p.tip) || 0;
  if (delivery === null && p.serviceType === 'delivery') {
    return { subtotal, delivery: null, total: null };
  }
  const deliverySnap = delivery ?? 0;
  return { subtotal, delivery: deliverySnap, total: subtotal + deliverySnap + tip };
}
